import { motion } from "framer-motion";

import { staggerContainer } from "../../utils/motion";

const StarWrapper = (Components, idName) =>
  function HOC() {
    return (
      <motion.section
        variants={staggerContainer()}
        initial='hidden'
        whileInView='show'
        viewport={{ once: true, amount: 0.25 }}
      >
        <span className='hash-span' id={idName}>
          &nbsp;
        </span>
        <Components />
      </motion.section>
    );
  };

export default StarWrapper;
